

// Settings for the plugin. The values below are defaults and can be overridden
module.exports = {
  // Whether to remember the previous devices picked or to prompt the user to choose.
  // The default is to prompt the user to choose. This only works if on https.
  usePreviousDeviceSelection: false,
};



// WEBPACK FOOTER //
// ./src/js/otplugin/settings.js